/**
 * @module types/settings/labelContent
 * @description 数据标签内容勾选列表（存储字段名 `labelContent`）
 *
 * 值为上传协议枚举：`metric` | `dimension` | `percent` | `total` 等。
 */

/** 数据标签内容多选列表 */
export type TLabelContent = string[];

/** 空列表的模块级默认引用（数组分支 @stable） */
export const LABEL_CONTENT_DEFAULT: TLabelContent = Object.freeze(
  [],
) as TLabelContent;
